<template>
  <div class="post-nav">
    <div class="post-nav-cell" v-if="next.id">
      <router-link
        :to="`/posts/${next.id}`"
        class="post-nav-btn"
      >
        <i class="bx bx-left-arrow-alt" style="margin-right: 10px"></i>
        {{ next.title }}
      </router-link>
    </div>
    <div class="post-nav-spacer"></div>
    <div class="post-nav-cell align-right" v-if="prev.id">
      <router-link
        :to="`/posts/${prev.id}`"
        class="post-nav-btn"
      >
        {{ prev.title }}
        <i class="bx bx-right-arrow-alt" style="margin-left: 10px"></i>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PostNavBtn',
  props: [
    'next',
    'prev'
  ]
}
</script>

<style scoped>
.post-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
}

.post-nav-cell {
  flex: 1;
}

.post-nav-spacer {
  flex: 1;
}

.post-nav-btn {
  display: inline-flex;
  align-items: center;
  padding: 10px 20px;
  border: 1px solid var(--p-button-outlined-border-color, #ccc);
  border-radius: 6px;
  text-decoration: none;
  color: var(--p-text-color, inherit);
  background: transparent;
  transition: background 0.2s;
}

.post-nav-btn:hover {
  background: var(--p-button-outlined-hover-background, rgba(0,0,0,0.04));
}

.align-right {
  text-align: right !important;
  display: flex;
  justify-content: flex-end;
}
</style>
